import { defineMessages } from 'react-intl';

export default defineMessages({
  locationStatePlaceholder: {
    defaultMessage: 'State code, e.g. NY',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.LocationState.locationStatePlaceholder`,
    description: 'Placeholder for a single US state code',
  },
  locationStateListPlaceholder: {
    defaultMessage: 'Comma separated, e.g. NY,CA',
    id: `app.containers.WorkflowEditor.components.Rules.Condition.LocationState.locationStateListPlaceholder`,
    description: 'Placeholder for a comma-separated list of US state codes',
  },
  locationStateHint: {
    defaultMessage:
      "Matches the state of the opening's location, not the applicant's own address.",
    id: `app.containers.WorkflowEditor.components.Rules.Condition.LocationState.locationStateHint`,
    description: 'Tooltip explaining which location the Location state condition matches',
  },
});
